// extracted by mini-css-extract-plugin
export default {"container":"TrialExpiration_container__fW+DU","link":"TrialExpiration_link__jMAQZ","icon":"TrialExpiration_icon__dgoZM","text":"TrialExpiration_text__1INE3"};